import { ICard } from '../../../../aer-types/types'

export const cards: ICard[] = []
